// Tiny className joiner. Accepts strings, falsy values and nested arrays.
export default function cn(...classes) {
  return classes.flat(Infinity).filter(Boolean).join(' ');
}
